import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';
import { Subscription, timer } from 'rxjs';

@Directive({
  selector: '[scClickToCopy]',
  standalone: true,
})
export class ClickToCopyDirective {
  @Input('scClickToCopy')
  contentToCopy!: string;
  @Input() showCopiedFeedback = false;

  private checkElement: HTMLElement | null = null;
  private checkIconSubscription: Subscription | null = null;

  @HostListener('click')
  copyToClipboard(): void {
    navigator.clipboard.writeText(this.contentToCopy);

    if (this.showCopiedFeedback) {
      this.showCheckIcon();
    }
  }

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  private showCheckIcon() {
    this.checkElement = this.renderer.createElement('span');
    this.renderer.addClass(this.checkElement, 'copy-check');
    this.renderer.setProperty(this.checkElement, 'innerHTML', 'copied ✔');

    this.renderer.setStyle(this.checkElement, 'position', 'absolute');
    this.renderer.setStyle(this.checkElement, 'bottom', '100%');
    this.renderer.setStyle(this.checkElement, 'right', '0');
    this.renderer.setStyle(this.checkElement, 'margin-bottom', '4px');
    this.renderer.setStyle(this.checkElement, 'whiteSpace', 'nowrap');

    this.renderer.setStyle(this.el.nativeElement, 'position', 'relative');
    this.renderer.appendChild(this.el.nativeElement, this.checkElement);

    if (this.checkIconSubscription) {
      this.checkIconSubscription.unsubscribe();
    }

    this.checkIconSubscription = timer(500).subscribe(() => {
      if (this.checkElement) {
        this.renderer.removeChild(this.el.nativeElement, this.checkElement);
        this.checkElement = null;
      }
    });
  }

  ngOnDestroy() {
    if (this.checkIconSubscription) {
      this.checkIconSubscription.unsubscribe();
    }
  }
}
